import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormComponent, ResponseErrorBoxComponent } from '@tokenbox/utils';
import { AsyncPipe } from '@angular/common';
import { TeamInvitationsCrudService } from '@tokenbox/services';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Panel } from 'primeng/panel';
import { PrimeIcons } from 'primeng/api';
import { TeamInvitationButtonsComponent } from '../team-invitation-buttons/team-invitation-buttons.component';

@Component({
  selector: 'dt-accept-invitations-dialog',
  imports: [
    ReactiveFormsModule,
    Panel,
    AsyncPipe,
    Button,
    ResponseErrorBoxComponent,
    TeamInvitationButtonsComponent,
  ],
  templateUrl: './accept-invitations-dialog.component.html',
  styleUrl: './accept-invitations-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcceptInvitationsDialogComponent implements FormComponent {
  protected readonly PrimeIcons = PrimeIcons;
  private invitationsCrudService = inject(TeamInvitationsCrudService);
  private dialogRef = inject(DynamicDialogRef);

  pendingInvitations$ =
    this.invitationsCrudService.pendingInvitationsForCurrentUser$;

  loading = signal(false);
  responseError = signal<Error | null>(null);

  close() {
    this.dialogRef.close();
  }
}
